/**
 * Returns the matched route pattern (e.g. `/menu-items/:uid`) instead of the
 * resolved path. Used for GA4 logging so dynamic route params never reach GA4
 * as distinct page paths. Falls back to the actual path if nothing matched.
 *
 * Accepts any route-like object (both `useRoute()` and the route passed to
 * `router.afterEach`), so it can be shared between components and plugins.
 */
export function getMatchedRoutePath(route: { matched: { path: string }[]; path: string }): string {
  return route.matched.at(-1)?.path ?? route.path;
}
